export const ROUTES = {
  home: '/',
  about: '/about',
  login: '/login',
  register: '/register',
  userProfile: '/profile/:id',
  settings: '/settings',
  'admin-front': '/admin-front',
  'admin-reviews': '/admin-front/reviews',
  'admin-support': '/admin-front/support',
  'admin-users': '/admin-front/users',
  'admin-promocodes': '/admin-front/promocodes',
  'admin-settings': '/admin-front/settings',
  'admin-masterclasses': '/admin-front/masterclasses',
  'admin-masterclasses-create': '/admin-front/masterclasses/create',
  'admin-masterclasses-edit': '/admin-front/masterclasses/edit/:id',
  'admin-discount': '/admin-front/discount',
  'admin-send-mc': '/admin-front/send-mc',
  'admin-send-mail': '/admin-front/send-mail',
  'admin-buyers-by-mc': '/admin-front/buyers-by-mc',
  'admin-broadcast': '/admin-front/broadcast',
  'admin-broadcast-new': '/admin-front/broadcast/new',
  'admin-broadcast-details': '/admin-front/broadcast/:id',
  'admin-categories-order': '/admin-front/categories-order',
  'admin-masterclasses-order': '/admin-front/masterclasses-order',
  cart: '/cart',
  meMasterclasses: '/me/masterclasses',
  favorites: '/me/favorites',
  masterclasses: '/masterclasses',
  masterclass: '/masterclasses/:id',
  masterclassesCategory: '/masterclasses/category/:value',
  course: '/course',
  me: '/me',
  contacts: '/contacts',
  privacy: '/privacy',
  consent: '/consent',
  termsOfUse: '/terms-of-use',
  paymentSuccess: '/payment-success',
  paymentError: '/payment-error',
  meReviews: '/me/reviews',
  support: '/support',
  offer: '/offer',
  'reviews-rules': '/reviews-rules',
  cookies: '/cookies',
  'add-review': '/masterclasses/:id/add-review',
  'register-thank': '/register-thank',
  'password-reset': '/password-reset',
  'admin-analytics': '/admin-front/analytics',
  blog: '/blog',
} as const;
